// Everpesa design tokens — modern fintech aesthetic
// Brand: deep, confident blue + warm accent for moments of action.

export const colors = {
  // Brand
  brand: "#0033CC",       // Everpesa primary blue
  brandDark: "#001F7A",   // hero background, deep press states
  brandDeep: "#000F3D",   // backgrounds for "trust" sections
  brandSoft: "#E6ECFF",   // tinted surfaces / pills
  brandLine: "#C8D4FF",   // hairline on tinted surfaces

  // Accent (used sparingly: highlights, badges, returns %)
  gold: "#F2B53D",
  goldSoft: "#FFF4D6",

  success: "#15A572",
  successSoft: "#E2F7EE",
  danger: "#E5484D",

  // Neutrals
  ink: "#0A0F1F",         // primary text on light
  inkMuted: "#4A536B",    // body text
  inkSoft: "#7A8299",     // captions, labels
  line: "#E6E9F2",        // dividers
  surface: "#FFFFFF",
  surfaceAlt: "#F6F8FC",  // page secondary backgrounds
  surfaceDark: "#0B1430", // alt dark surface

  white: "#FFFFFF",
  black: "#000000",
};

export const fonts = {
  display: `'Sora', 'Inter', system-ui, -apple-system, BlinkMacSystemFont, sans-serif`,
  body: `'Inter', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif`,
  mono: `ui-monospace, 'SF Mono', Menlo, Consolas, monospace`,
};

export const radius = {
  xs: "6px",
  sm: "10px",
  md: "14px",
  lg: "20px",
  xl: "28px",
  pill: "999px",
};

export const shadows = {
  sm: "0 1px 2px rgba(10, 15, 31, 0.06), 0 1px 3px rgba(10, 15, 31, 0.04)",
  md: "0 6px 16px rgba(10, 15, 31, 0.08), 0 2px 4px rgba(10, 15, 31, 0.04)",
  lg: "0 24px 48px -12px rgba(10, 15, 31, 0.18), 0 8px 16px -8px rgba(10, 15, 31, 0.08)",
  glow: "0 20px 60px -20px rgba(0, 51, 204, 0.45)",
};

export const breakpoints = {
  sm: "640px",
  md: "860px",
  lg: "1100px",
  xl: "1320px",
};

export const media = {
  sm: `@media (max-width: ${breakpoints.sm})`,
  md: `@media (max-width: ${breakpoints.md})`,
  lg: `@media (max-width: ${breakpoints.lg})`,
  xl: `@media (max-width: ${breakpoints.xl})`,
};

export const ease = "cubic-bezier(0.22, 1, 0.36, 1)";
